import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";

const EmailTemplate = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Email Setup" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Email Setup</p>
      </div>

      <div className="ml-4 w-[70%] bg-[#F8F8F8] mt-8 p-4 rounded-lg text-[#828282]">
        <div className="flex justify-between">
          <p className="text-[20px]">Follow up</p>
          <img
            src={edit_pencil_icon}
            alt="edit"
            className="object-contain w-4"
          />
        </div>
        <div className="mt-4">Follow up email on the request</div>
        <div className="w-[70%] mt-4">
          Hope you are doing well. This email is for following up with you on
          the requested on the products.Kindly go through the attachment below
          in this email.
        </div>
      </div>

      <p className="text-[#2F80ED] text-[16px] underline mt-6 ml-4">
        Create New
      </p>
    </div>
  );
};

export default EmailTemplate;
